export function chunk(arr, chunkSize) {
  const array = [...arr];
  return Array(Math.ceil(array.length / chunkSize)).fill().map(function (_, i) {
    return array.slice(i * chunkSize, i * chunkSize + chunkSize);
  });
}